import Vue from 'vue'
import moment from 'moment'
moment.locale('id')
Vue.filter('parse', (value, id) => {
  if (id === null || id === undefined) return value
  if (value === null || value === undefined) return value
  let toReturn = ''
  if (id.search('-') === -1) {
    switch (id) {
      case 'active':
        toReturn = value === 1 ? 'Data Aktif' : 'Non Aktif'
        break
      case 'valsal':
        toReturn = value === 'valsal' ? 'Vendor/Subkon' : 'Kontraktor'
        break
      case 'verification_order':
        if (value === 1) toReturn = 'Dibuat,'
        if (value === 2) toReturn = 'Menyetujui,'
        if (value === 3) toReturn = 'Mengetahui Menyetujui,'
        break
      case 'uppercase':
        toReturn = value.toUpperCase()
        break
      case 'allow':
        toReturn = value.toLowerCase() === 'y' ? 'DIperbolehkan' : 'Tidak diizinkan'
        break
      case 'lock':
        toReturn = value.toLowerCase() === 'y' ? 'Close' : 'Open'
        break
      case 'yn':
        toReturn = value.toLowerCase() === 'y' ? 'Ya' : 'Tidak'
        break
      case 'verify':
        if (value === 'revision_request') toReturn = 'Permintaan Revisi'
        else if (value === 'verification_request') toReturn = 'Pengajuan Verifikasi'
        else if (value === 'appraisal_request') toReturn = 'Permintaan Penilaian'
        else if (value === 'approved') toReturn = 'Disetujui'
        else toReturn = 'Draft'
        break
      case 'modules':
        if (value === 'customer_complaints') toReturn = 'Keluhan Pelanggan'
        else if (value === 'kkkl_daily_reports') toReturn = 'K3L Daily'
        else if (value === 'mm_appraisals') toReturn = 'SMM'
        else if (value === 'qhse_daily_activities') toReturn = 'Daily Activity'
        else if (value === 'qhse_nc_qa') toReturn = 'Non Conformance'
        else if (value === 'qpass_appraisals') toReturn = 'QPASS'
        else if (value === 'qpass') toReturn = 'QPASS'
        else if (value === 'smkkkl_appraisals') toReturn = 'SMK3L'
        else if (value === 'r_appraisals') toReturn = '5R'
        else if (value === 'qhse_nc_hse') toReturn = 'HSE NC'
        else if (value === 'kkkl_accident_cause_analysis') toReturn = 'Analisa Penyebab'
        else if (value === 'kkkl_occupt_diss_accidents') toReturn = 'Kecelakaan / Penyakit Akibat Kerja'
        else if (value === 'kkkl_critical_plans') toReturn = 'Rencana Tugas Kritikal'
        else if (value === 'kkkl_onsite_kkkl_personnels') toReturn = 'Tenaga K3L On Site'
        else if (value === 'kkkl_trainings') toReturn = 'Pelatihan K3L'
        else if (value === 'users_verifications') toReturn = 'Verifikasi Pendaftaran'
        else if (value === 'smkk') toReturn = 'SMKK'
        else if (value === 'smkk_result') toReturn = 'SMKK'
        else toReturn = 'Unknown'
        break
      case 'number':
        toReturn = !isNaN(value) ? Number(value).toLocaleString('id') : value
        break
      case 'number2fraction':
        toReturn = !isNaN(value) ? Number(value).toLocaleString('id', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : value
        break
      case 'longDate':
        toReturn = moment(value).format('LL')
        break
      case 'dateOnly':
        toReturn = moment(value).format('DD')
        break
      case 'longDateTime':
        toReturn = moment(value).format('LLLL')
        break
      case 'period':
        toReturn = moment(value).format('MMMM YYYY')
        break
      case 'month':
        toReturn = moment(value).format('MMMM')
        break
      case 'year':
        toReturn = moment(value).format('YYYY')
        break
      case 'kelamin':
        toReturn = value.toLowerCase() === 'l' ? 'Laki-Laki' : 'Perempuan'
        break
      case 'status_code':
        let temp = value.toLowerCase().split('_').map((kebab) => kebab.toLowerCase().charAt(0).toUpperCase() + kebab.slice(1)).join(' ')
        if (value === 'approved') temp = 'Close & ' + temp
        toReturn = temp
        break
      case 'qa_criteria':
        toReturn = value.toLowerCase() === 'hse' ? 'HSE' : 'Quality'
        break
      case 'handling_category':
        if (value === 'corporate') toReturn = 'Corporate'
        else if (value === 'department') toReturn = 'Departemen'
        else toReturn = 'Proyek'
        break
      case 'caused_by':
        if (value === 'other') toReturn = 'Lainnya'
        else if (value === 'mandor') toReturn = 'Mandor'
        else toReturn = 'Sub Kontraktor'
        break
      case 'action_plan_option':
        if (value === 'as_its') toReturn = 'Diterima apa adanya (As it is)'
        else if (value === 'repair') toReturn = 'Diperbaiki (Repair)'
        else if (value === 'reject') toReturn = 'Dibongkar (Reject)'
        else toReturn = 'Downgrade'
        break
      case 'risk_level':
        if (value === 1) toReturn = 'Rendah'
        else if (value === 2) toReturn = 'Sedang'
        else toReturn = 'Tinggi'
        break
      case 'single_number_type':
        if (value === 'smk3l') toReturn = 'SMK3L'
        else if (value === 'mm') toReturn = 'Manajemen Mutu'
        else toReturn = 'Penilaian 5R'
        break
      case 'survey_type':
        if (value === 'owner_representatif') toReturn = 'Owner representatif'
        else if (value === 'consultant') toReturn = 'Consultant'
        else if (value === 'partner') toReturn = 'Rekanan ADHI'
        else toReturn = 'Downgrade'
        break
      default:
        toReturn = value
    }
  } else {
    switch (id.split('-')[0]) {
      case 'prefix':
        toReturn = id.split('-')[1] + ' ' + value
        break
      case 'suffix':
        toReturn = value + ' ' + id.split('-')[1]
        break
      default:
        toReturn = value
    }
  }
  return toReturn
})
export default {
  name: 'filterTemplate'
}



// WEBPACK FOOTER //
// ./src/utils/filter.js